@if (routeCategoryItems && routeCategoryItems.length > 0) {
<mat-accordion [hideToggle]="true" [multi]="isExpandedMulti" displayMode="flat">
  @for (routeCategoryItem of routeCategoryItems; track routeCategoryItem) {
  <mat-expansion-panel
    [expanded]="isExpanded"
    [id]="'all_sidebar_acc_route-category--' + routeCategoryItem.category.id"
    class="accordion-panel mat-elevation-z0"
  >
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon class="mr-2">{{ routeCategoryItem.category.icon }}</mat-icon>
        {{ routeCategoryItem.category.label | transloco }} ({{ routeCategoryItem.routes.length }})
      </mat-panel-title>
    </mat-expansion-panel-header>
    <fr-sidebar-route-list
      (removeRoute)="removeRoute.emit($event)"
      [expanded]="expanded"
      [routes]="routeCategoryItem.routes"
    ></fr-sidebar-route-list>
  </mat-expansion-panel>
  }
</mat-accordion>
}
